import { authorizedApi } from './index';

export const notificationsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomGiftCardDesigns: builder.query({
      query: () => '/users/me/custom-designs',
    }),
    createCustomGiftCardDesign: builder.mutation({
      query: ({ image }) => ({
        url: `/users/me/custom-designs`,
        method: 'POST',
        body: {
          image,
        },
      }),
    }),
    deleteCustomGiftCardDesign: builder.mutation({
      query: ({ imageUrl }) => ({
        url: `/users/me/custom-designs/`,
        method: 'DELETE',
        body: {
          imageUrl,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCustomGiftCardDesignsQuery,
  useCreateCustomGiftCardDesignMutation,
  useDeleteCustomGiftCardDesignMutation,
} = notificationsApi;
